// Plugin
import "./jquery-global";
import "slick-carousel";
import "./svgxuse";

// Polyfill
import "intersection-observer";
import Sticky from "./sticky";
import "nodelist-foreach-polyfill";

// By Page
import Top from "./top";
import ValueSlider from "./valueSlider";
import SearchCondition from "./searchCondition";
import DetailModules from "./detail";
import WorkStyle from "./workStyle";
import Faq from "./faq";
import JobSlider from "./jobSlider";

// By Component
import ToTop from "./toTop";
import Ua from "./ua";
import Tab from "./tab";
import Modal from "./modal";
import Menu from "./menu";
import TextCut from "./textcut";
import GetChannelArticles from "./getChannelArticles";
import ObjFit from "./objFit";
import WatchVideo from "./watchVideo";
import floatLink from "./floatLink";
import smoothScroll from "./smoothScroll";
import HandleMetaBall from "./metaBall";
import setVideo from "./setVideo";

(function () {
  // SETTING
  const breakPoint = 767;
  const breakPointTablet = 1024;

  // IE
  Ua();

  // Position Sticky Polyfill
  Sticky();
  ObjFit();

  // Components
  Tab();
  Modal();
  TextCut();
  if ($("#js-toTop").length > 0) {
    ToTop(breakPointTablet);
    WatchVideo(breakPointTablet);
  }

  if ($(".js-floatLink").length > 0) {
    floatLink();
  }

  // Top
  if ($("body").hasClass("recruit-top")) {
    Top(breakPoint);
    GetChannelArticles(breakPoint);
    ValueSlider();
  }

  // Value
  if ($("body").hasClass("recruit-value")) {
    ValueSlider();
  }

  // Search
  if ($("body").hasClass("recruit-search")) {
    SearchCondition();
  }

  // Detail
  if ($("body").hasClass("recruit-detail")) {
    DetailModules();
  }

  // WorkStyle
  if ($("body").hasClass("recruit-workstyle")) {
    WorkStyle();
  }

  // FAQ
  if ($("body").hasClass("recruit-faq")) {
    Faq(breakPoint);
  }
  // METAVERSE
  if ($("body").hasClass("recruit-metaverse")) {
    JobSlider(breakPoint);
    smoothScroll();
    HandleMetaBall();
    setVideo()
  }

  Menu();
})();



// WEBPACK FOOTER //
// ./src/recruit/js/app.js